export default __webpack_public_path__ + "static/9-ways-to-survive-a-european-winter-tour-c6bfcabd7ffc4f1ff283e79d9d29a0dc.jpg";